import { isCnp } from "utils/simple-validations";

export const hasAuthorization = (code, rights) => Boolean(rights?.rights?.some(x => x === code));

export const objToQueryString = (obj, overrides) => {
  const copy = Object.assign(obj, overrides || {});
  const searchParams = new URLSearchParams();
  Object.entries(copy).forEach(([key, value]) => {
    if (Array.isArray(value) && value.length) {
      value.forEach(v => searchParams.append(key, v));
    } else {
      if (value !== "" && value !== null && value !== undefined && typeof value !== "object")
        searchParams.set(key, value);
    }
  });
  return searchParams.toString();
};

export const getRandomInt = (min, max) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min)) + min;
};

export const clean = obj => {
  Object.keys(obj).forEach(
    key =>
      (obj[key] == null ||
        obj[key] === undefined ||
        obj[key] === "" ||
        (typeof obj[key] === "number" && isNaN(obj[key]))) &&
      delete obj[key]
  );
};

export const getInt = nr => {
  let o = parseInt(nr, 10);
  if (isNaN(o)) return null;
  return o;
};

export const changeValueInArray = (list, keyName, keyValue, propertyName, propertyValue) => {
  return list.map(el => (el[keyName] === keyValue ? Object.assign({}, el, { [propertyName]: propertyValue }) : el));
};

export const isEmpty = obj => {
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
  }
  return true;
};

export const groupBy = (array, f) => {
  let groups = {};
  array.forEach(function (o) {
    var group = JSON.stringify(f(o));
    groups[group] = groups[group] || [];
    groups[group].push(o);
  });
  return Object.keys(groups).map(function (group) {
    return groups[group];
  });
};

export const extractAgeFromCnp = p_cnp => {
  if (p_cnp && isCnp(p_cnp)) {
    // Extract birthday
    const extraDateValues = "00:00:00 +0000";
    const sex = parseInt(p_cnp[0], 10);
    let year = parseInt(`${p_cnp[1]}${p_cnp[2]}`, 10);
    const month = parseInt(`${p_cnp[3]}${p_cnp[4]}`, 10);
    const day = parseInt(`${p_cnp[5]}${p_cnp[6]}`, 10);

    switch (sex) {
      case 1:
      case 2:
        year += 1900;
        break;
      case 3:
      case 4:
        year += 1800;
        break;
      case 5:
      case 6:
        year += 2000;
        break;
      case 7:
      case 8:
      case 9:
        year += 2000;
        if (year > new Date().getFullYear() - 18) {
          year -= 100;
        }
        break;
      default: {
        return undefined;
      }
    }

    if (year < 1800 || year > 2099) {
      return undefined;
    }

    const birthday = Date.parse(`${year}-${month}-${day} ${extraDateValues}`);

    // Extract age
    const diff_ms = Date.now() - birthday;
    const age_dt = new Date(diff_ms);
    return age_dt.getUTCFullYear() - 1970;
  }

  return undefined;
};

export const combineKeys = (key1, key2) => {
  return `${key1}_${key2}`;
};

export function camelize(str) {
  if (!str) return "";
  return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match, index) {
    if (+match === 0) return ""; // or if (/\s+/.test(match)) for white spaces
    return index === 0 ? match.toLowerCase() : match.toUpperCase();
  });
}

export const getDynamicFieldProperties = typeCode => {
  switch (typeCode) {
    case "TP_TEXT":
      return { controlType: "Text" };
    case "COMBO":
    case "COMBO_LAZY":
    case "SEARCH":
    case "SELECT":
    case "SEARCH_BIT":
    case "AUTOCOMPLETE":
    case "ADAPTIVE_LOOKUP":
      return { controlType: "Autocomplete" };
    case "ADAPTIVE_LOOKUP_MULTI":
      return { controlType: "Autocomplete", isMultiSelection: true };
    case "TP_NUM":
    case "AMOUNT":
    case "INT":
      return { controlType: "Numeric" };
    case "TP_DATE":
    case "YEAR":
    case "MONTHYEAR":
    case "DATE":
      return { controlType: "Date" };
    case "BOOL":
      return { controlType: "Checkbox" };
    case "CHECK_BOX_INDETERMINATE":
      return { controlType: "Checkbox", indeterminate: true };
    case "PHONE_NUMBER":
      return { controlType: "Custom" };
    default:
      return { controlType: typeCode || "Text" };
  }
};

export const withPropsExclusion = props => {
  if (!props) return;
  if (Array.isArray(props) && props.length === 0) return;
  if (!Array.isArray(props) && typeof props !== 'string') return;

  return {
    shouldForwardProps: prop => {
      if (typeof props === 'string') return prop !== props;
      return !props.includes(prop);
    }
  };
};